import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=7d504476&scoped=true&"
import script from "./DetailsPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=7d504476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d504476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d504476')) {
      api.createRecord('7d504476', component.options)
    } else {
      api.reload('7d504476', component.options)
    }
    module.hot.accept("./DetailsPanel.vue?vue&type=template&id=7d504476&scoped=true&", function () {
      api.rerender('7d504476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/DetailsPanel.vue"
export default component.exports